var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 16,
    viewBox: "0 0 30 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1C9 0.447715 9.44772 0 10 0H20C20.5523 0 21 0.447715 21 1V13.6988C21 14.5732 19.9569 15.0264 19.3177 14.4298L15.6823 11.0368C15.2981 10.6782 14.7019 10.6782 14.3177 11.0368L10.6823 14.4298C10.0431 15.0264 9 14.5732 9 13.6988V1Z",
    fill: "#FF002F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteRed);
export default __webpack_public_path__ + "static/media/favorite_red.05cea62eed709816ef1e22553ca7d173.svg";
export { ForwardRef as ReactComponent };